import { render, staticRenderFns } from "./BusinessPlatformArticle.vue?vue&type=template&id=ba0764ea&scoped=true&"
import script from "./BusinessPlatformArticle.vue?vue&type=script&lang=js&"
export * from "./BusinessPlatformArticle.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPlatformArticle.vue?vue&type=style&index=0&id=ba0764ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0764ea",
  null
  
)

export default component.exports